import { Directive, HostListener, Input } from '@angular/core'

@Directive({
  selector: '[appPasteValidator]',
  standalone: false,
})
export class PasteValidatorDirective {
  @Input() appPasteValidator: 'decimal' | 'integer' = 'decimal'

  private readonly decimalPattern = /^[-+]?\d*\.?\d{0,2}$/
  private readonly integerPattern = /^[-+]?\d+$/

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault()

    const clipboardData = event.clipboardData || (window as any).clipboardData
    let paste = clipboardData?.getData('text')?.replace(/[$,+]/g, '').trim()
    if (!paste) return

    const isDecimal = this.appPasteValidator !== 'integer'
    const regex = isDecimal ? this.decimalPattern : this.integerPattern

    // For decimal, limit to 2 decimals if numeric
    if (isDecimal && !isNaN(Number(paste))) {
      paste = Number(Number(paste).toFixed(2)).toString()
    }

    if (!regex.test(paste)) return

    const target = event.target as HTMLInputElement
    const { selectionStart = 0, selectionEnd = 0, value } = target
    const newValue =
      value.slice(0, selectionStart) + paste + value.slice(selectionEnd)

    if (newValue === '' || isNaN(Number(newValue)) || !regex.test(newValue))
      return

    target.value = newValue
    target.dispatchEvent(new Event('input', { bubbles: true }))
  }
}
